<template>
  <div class="chat-root">
    <div class="chat-container">
      <div class="messages" ref="messages"></div>
    </div>
    <div class="input-area">
      <input type="text" v-model="userInput" @keypress.enter="sendMessage" placeholder="输入你的问题..." id="user-input" />
      <button @click="sendMessage">发送</button>
    </div>
  </div>
</template>

<script setup>
import { goToLogin } from '@/utils/loginFlow'
import { ref, nextTick, onMounted } from 'vue'
import { marked } from 'marked'
import { sanitizeHtml } from '@/utils/sanitizeHtml'
import { useRouter } from 'vue-router'

const router = useRouter()

// 检查是否登录
const checkLogin = () => {
  if (!localStorage.getItem('jwt_token')) {
    goToLogin(router)
    return false
  }
  return true
}

// 在组件挂载时检查登录状态
onMounted(() => {
  if (!checkLogin()) {
    return
  }
})

const userInput = ref('')
const chatHistory = ref([])
const messages = ref(null)

function scrollToBottom() {
  nextTick(() => {
    if (messages.value) {
      messages.value.scrollTop = messages.value.scrollHeight
    }
  })
}

function addMessageToUI(role, content) {
  const div = document.createElement('div')
  div.className = `message ${role}-message markdown`
  // 处理 \u003cthink\u003e 标签
  let processedContent = content.replace(/\\u003cthink\\u003e/g, '<span class="think-highlight">')
  processedContent = processedContent.replace(/\\u003c\/think\\u003e/g, '</span>')
  div.innerHTML = sanitizeHtml(marked.parse(processedContent))
  messages.value.appendChild(div)
  scrollToBottom()
  return div
}

function createAssistantContainer() {
  const container = document.createElement('div')
  container.className = 'assistant-message-container'
  const messageDiv = document.createElement('div')
  messageDiv.className = 'message assistant-message markdown'
//   messageDiv.textContent = '正在生成回答...'
//   const thinkDiv = document.createElement('div')
//   thinkDiv.className = 'think-box'
//   thinkDiv.textContent = '正在思考...'
  container.appendChild(messageDiv)
//   container.appendChild(thinkDiv)
  messages.value.appendChild(container)
  scrollToBottom()
  return { container, messageDiv  }
}

async function sendMessage() {
  if (!userInput.value.trim()) return
  const userMessage = userInput.value.trim()
  userInput.value = ''
  chatHistory.value.push({ role: 'user', content: userMessage })
  addMessageToUI('user', userMessage)
  const { messageDiv, thinkDiv } = createAssistantContainer()
  const data = {
    model: 'qwen3:0.6b',
    messages: chatHistory.value,
    stream: true
  }
  let fullResponse = ''
//   simulateThinking(thinkDiv, userMessage)
  try {
    const response = await fetch('/api/v1/ai/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let done = false
    let isThinking = false
    while (!done) {
      const { done: isDone, value } = await reader.read()
      done = isDone
      if (value) {
        const chunk = decoder.decode(value)
        const lines = chunk.split('\n')
        for (const line of lines) {
          if (line.trim()) {
            
            try {
              const json = JSON.parse(line)
              if (json.message?.content) {
                let content = json.message.content
                console.log("content=", content)
                if (content==='<think>')  {
                    console.log("thinking")
                    isThinking = true
                    content = '<div class="think">'
                        console.log("isThinking=", isThinking)
                    
                } else if (content==='</think>')  {
                    console.log("thinking end")
                    isThinking = false
                    content = '</div>'
                    console.log("isThinking=", isThinking)
                }
                

                fullResponse += content

                // if (!isThinking) {
                //     fullResponse += content
                // } else {
                //     fullResponse += '_' + content + '_'
                // }
                 
                 
                messageDiv.innerHTML = sanitizeHtml(marked.parse(fullResponse))
                scrollToBottom()
              }
            } catch (e) {
              // ignore parse error
            }
          }
        }
      }
    }
    
    chatHistory.value.push({ role: 'assistant', content: fullResponse })
  } catch (error) {
    messageDiv.textContent = '发送请求时出错，请重试'
    thinkDiv.textContent = '思考过程中断: 发生错误'
  }
}

// function simulateThinking(thinkElement, question) {
//   let thoughts = []
//   if (question.toLowerCase().includes('sky blue')) {
//     thoughts = [
//       '用户问为什么天空是蓝色的...',
//       '我记得这和光的散射有关...',
//       '应该是瑞利散射现象...',
//       '太阳光中的蓝色光波长较短，更容易被大气中的分子散射...',
//       '所以我们看到的天空主要是蓝色的...',
//       '需要确认一下是不是还有其他因素...'
//     ]
//   } else {
//     thoughts = [
//       '用户问的是：' + question,
//       '我需要先理解这个问题的核心...',
//       '让我想想相关的知识点...',
//       '可能的答案方向是...',
//       '需要组织语言，给出清晰的解释...'
//     ]
//   }
//   let index = 0
//   let currentText = ''
//   function typeThought() {
//     if (index < thoughts.length) {
//       if (currentText.length < thoughts[index].length) {
//         currentText += thoughts[index].charAt(currentText.length)
//         thinkElement.textContent = currentText
//         setTimeout(typeThought, 50)
//       } else {
//         currentText += '\n'
//         thinkElement.textContent = currentText
//         index++
//         setTimeout(typeThought, 1000)
//       }
//     }
//   }
//   typeThought()
// }
</script>

<style>
.chat-root {
  display: flex;
  flex-direction: column;
  height: 80vh;
  min-height: 0;
}
.chat-container {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  padding: 0 10px;
  min-height: 0;
}
.messages {
  flex: 1 1 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  min-height: 0;
  margin-bottom: 0;
  padding: 10px;
  overflow-y: auto;
  background: #fff;
  max-height: 100%;
  display: flex;
  flex-direction: column;
}
.input-area {
  display: flex;
  gap: 10px;
  max-width: 800px;
  margin: 0 auto 0 auto;
  width: 100%;
  padding: 10px 10px 0 10px;
  background: #fff;
  box-sizing: border-box;
}
#user-input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}
button {
  padding: 8px 16px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #0b7dda;
}
.message {
  margin: 10px 0;
  padding: 10px;
  border-radius: 6px;
  max-width: 80%;
}
.user-message {
  background-color: #f5f5f5; /* 灰色底色 */
  margin-left: auto;
  margin-right: 0;
  text-align: right;
  align-self: flex-end;
}
.assistant-message-container {
  margin-right: auto;
  max-width: 80%;
}
.assistant-message {
  background-color: #f5f5f5;
  margin-bottom: 5px;
}
.think-box {
    
  background-color: #fff8e1;
  border-left: 4px solid #ffc107;
  padding: 10px;
  font-size: 0.9em;
  border-radius: 0 6px 6px 0;
}
.think-highlight {
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 3px;
}
.markdown p {
  margin: 0 0 10px 0;
}
.markdown strong {
  font-weight: bold;
}
.markdown em {
  font-style: italic;
}
.markdown code {
  background-color: #eee;
  padding: 2px 4px;
  border-radius: 2px;
  font-family: monospace;
}
.markdown pre {
  background-color: #eee;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: monospace;
  margin: 0 0 10px 0;
}
.markdown h1, .markdown h2, .markdown h3 {
  margin: 15px 0 10px 0;
}
.markdown ul, .markdown ol {
  margin: 0 0 10px 20px;
}
   
   .think {

    background-color: #fff8e1;
  border-left: 4px solid #ffc107;
  padding: 10px;
  font-size: 0.9em;
  border-radius: 0 6px 6px 0;
  margin-bottom: 1em;
  margin-top: 1em;
/*   
    font-size: small;
    background-color: #f0f0f0;
    padding: 2px 4px;
    border-radius: 3px; */
   }
</style> 